const SERVICE = "market";

const getFavourites = async (api,userId) =>
  api.setMethod().get().setService(SERVICE).process(`/favourites/${userId}`);

const updateFavourites = async (api,body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/favourites");

module.exports = {
  getFavourites,
  updateFavourites,
};
